$('.slider').slick({
	infinite: true,
	dots: false,
	arrows: true,
	mobileFirst: true,
	speed: 500,
	fade: true,
	autoplay: true,
	autoplaySpeed: 3000,
	cssEase: 'linear'
});
/*$('#carousel-review').find('.item.active').find('.slide__info-text-link').show();

$('#carousel-review').on('slide.bs.carousel', function () {
	$('.slide__info-text').removeClass("active");
});

$('#carousel-review').on('slid.bs.carousel', function (){
	var $slideItem = $(this).find('.item.active');
	var $slideText = $slideItem.find('.slide__info-text').height();
	var	$slideTextCont = $slideItem.find('.slide__info-text>span').height();

	if($slideTextCont > $slideText) {
		$slideItem.find('.slide__info-text-link').show();
	}
});
$('.slide__info-text-link').click(function(){
	$('.slide__info-text').toggleClass("active");
});*/



// WEBPACK FOOTER //
// ./_dev/blocks/slider/slider.js